<template>
  <v-card>
    <v-card-title>
      SDS-Editor
    </v-card-title>
    <v-card-subtitle>
      Neue Nachricht
    </v-card-subtitle>
    <v-card-text>
        <v-container>
          <v-row>
            <v-col
              cols="12"
            >
              <v-autocomplete
                v-model="new_sds.receiver"
                chips
                multiple
                :items="[]"
                :item-text="item => (item.display_name.length == 0) ? item.issi : item.display_name +' ('+ item.issi + ')'"
                item-value="issi"
                clearable
                deletable-chips
                hide-no-data
                label="Empfänger"
                hint="Filteroptionen: OPTA, ISSI oder Beschreibung"
                persistent-hint
                disabled
              >
              </v-autocomplete>
            </v-col>
            <v-col
              cols="12"
            >
              <v-textarea
                v-model="new_sds.text"
                ref="textbox"
                :hint="new_sds.text.length + ' von 85 Zeichen.'"
                persistent-hint
                no-resize
                maxlength="85"
                disabled
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "SDSEditor",
  props: ["new_sds"],
  data: () => ({
    search: null,
    sz_checker_string: /^[a-zA-Z0-9,.:!?*+-/%/\s&üöäÜÖÄß]*$/,
  }),
};

//                <!--- :rules="validate_sds_text" --->
//<!---:filter="onFilter"
//search-input.sync="search" --->

</script>

<style scoped>

</style>
